import { render, staticRenderFns } from "./tree-templateField.vue?vue&type=template&id=4765f4ac&scoped=true&"
import script from "./tree-templateField.vue?vue&type=script&lang=js&"
export * from "./tree-templateField.vue?vue&type=script&lang=js&"
import style0 from "./tree-templateField.vue?vue&type=style&index=0&id=4765f4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765f4ac",
  null
  
)

export default component.exports